import { ImportFromSystemType } from '../../shared/constants/input.constants';
import { ThemeActionType } from '../../shared/constants/question.constants';
import { QuestionFilterDataModel } from '../summary/summary.model';
import {PeopleModel, PeopleSearchPDModel} from './../people/people.model';

export enum SurveyCreateType {
  BrandNewSurvey = 1,
  DuplicateExistingSurvey
}

export enum SurveyTabs {
  Create = 1,
  Define = 2,
  Intro = 3,
  Question = 4,
  Review = 5
}

export enum DifferenceType {
  Relative = 'Relative',
  Absolute = 'Absolute'
}

export enum ClientEnum {
    INTERNAL = 'Internal',
}

// export enum SurveyActions {
//     AddToExistingSurvey = 1,
//     CreateNewSurveyFromSelection
// }
export class SurveyCreatePDModel {
  tabId: number;
  isEditable: boolean;
  id: number;
  cameFromPeople: boolean;
  oldStatus: number;
  infoText: string;
  clientName: string;
  appropriateFormat: string;
  appropriateFormatPop: boolean;
  selectedCreateType: string;
  maximumNumberParticipants: number;
  isPeopleDataEnrichment: boolean;
  workshopSurvey: boolean;
  status: number;
  enumStatus: string;
  surveyType: number;
  dateCreated: string;
  title: string;
  clientId: number;
  createdById: number;
  whatToLearn: string;
  whatToLearnPop: boolean;
  whoToTalk: string;
  whoToTalkPop: boolean;
  introForParticipants: string;
  surveyGroundRules: string;
  numberOfParticipants: number;
  numberOfQuestions: number;
  numberOfLanguages: number;
  totalSelectedPeopleCount: number;
  dueDate: Date;
  listEnumSurveyCreateType: any; // todo define this type
  selectedSurveyModelCopyFrom: SurveyModel;
  listSurveyModel: SurveyModel[];
  listSrvUserModel: SrvUserModel[];
  listClientModel: ClientModel[];
  selectedClientModel: ClientModel;
  peopleSearchPDModel: PeopleSearchPDModel;
  listPeopleSurveyModel: SurveyModel[];
  listPeopleTemp: PeopleModel[];
  listLanguageModel: LanguageModel[];
  listSelectedSurveyLanguageModel: SurveyLanguageModel[];
  listSurveyQuestionModel: SurveyQuestionModel[];
  listEnumModelAnswerType: AnswerTypes[];
  listPeopleSurveyCurrencyModel: PeopleSurveyCurrencyModel[];
  listSurveyLanguageHashModel: ListSurveyLanguageHashModel[];
  backEnabled: boolean;
  workspaceName: string;
}

export class SurveyModel {
  id: number;
  title: string;
}

export class SurveyMailListModel {
  id: number;
  syncToMailchimp: boolean;
  mailchimpAudience: string;
  questionNumberForEmail: number;
  questionNumberForName: number;
}

export class SrvUserModel {
  id: number;
  fullName: string;
}

export class ClientModel {
  id: number;
  name: string;
  active?: boolean;
  licenseTier?: string;
  licenseTierId?: number;
  expiryDate?: string;
  typeFormActivated?: boolean;
  typeFormToken?: string;
  surveyMonkeyActivated?: boolean;
  surveyMonkeyToken?: string;
}

export class LanguageModel {
  id: number;
  name: string;
}

export class SurveyLanguageModel {
  surveyId: number;
  languageId: number;
  translatorId: number;
  dateCreated: string;
  languageName: string;
}

export class SurveyQuestionModel {
  id: number;
  parentId: number;
  surveyId: number;
  question: string;
  answerType: string;
  questionDescription: string;
  dataName: string;
  dateCreated: string;
  listSurveyQuestionAnswerModel: SurveyQuestionAnswerModel[];
  listSurveyQuestionLanguageModel: SurveyQuestionLanguageModel[];
  guid: number;
  parentGuid: number;
  isRequired: boolean;
  max: number;
  childQuestions: any;
  jumpToQuestionId: number;
  public check: boolean;
  isFilter: boolean;
  surveyQuestionAnswers: SurveyQuestionAnswerModel[];
  maxThresholdResponse: number;
  minThresholdResponse: number;
  isInputResponseRange: boolean;
  isToggle: boolean;
  exceptionWord: string;
  questionBundle: string;
  constructor()
  constructor(guid: number, surveyId: number, parentGuid: number)
  constructor(guid?: number, surveyId?: number, parentGuid?: number) {
    this.guid = guid;
    this.surveyId = surveyId;
    this.parentGuid = parentGuid;
    this.listSurveyQuestionAnswerModel = [];
    this.question = 'Question';
    this.childQuestions = [];
    this.answerType = 'SingleChoice';
    this.isRequired = true;
    this.isFilter = true;
    this.isInputResponseRange = false;
    this.isToggle = false;
  }

}

export class SurveyQuestionFilterRawModel {
  id: number;
  question: string;
  answerType: string;
  listSurveyAnswerFilter: SurveyAnswerFilterRawModel[];
}

export class SurveyAnswerFilterRawModel {
  id: number;
  answer: string;
}

export class SimpleSurveyQuestion {
  id: number;
  question: string;
  isSelected = false;

  constructor(id: number, question: string) {
    this.id = id;
    this.question = question;
    this.isSelected = false;
  }
}

export class FilterUIModel {
  isOrOperator: string;
  listSurveyFilterUI: SurveyFilterUIModel[];
  segmentName: string;

  constructor(filter: string, listSurveyFilter: SurveyFilterUIModel[], name: string) {
    this.isOrOperator = filter;
    this.listSurveyFilterUI = listSurveyFilter;
    this.segmentName = name;
  }
}

export class SurveyFilterUIModel {
  isChecked: boolean;
  question: SurveyQuestionFilterRawModel;
  listAnswerId: number[];
  operator: string;
  input: string;
  isOrOpr: boolean;

  constructor() {
    this.isChecked = true;
    this.question = null;
    this.listAnswerId = null;
    this.isOrOpr = this.isOrOpr || true;
  }
}

export class SurveyQuestionAnswerModel {
  id: number;
  surveyId: number;
  surveyQuestionId: number;
  answer: string;
  dateCreated: string;
  jumpToQuestionId: number;
  listSurveyQuestionAnswerLanguageModel: SurveyQuestionAnswerLanguageModel[];
  theme: string;

  // new property
  public dropDown: boolean;
  public check: boolean;

  constructor(surveyId: number, surveyQuestionId: number) {
    this.surveyId = surveyId;
    this.surveyQuestionId = surveyQuestionId;
  }
}

export class SurveyQuestionAnswerLanguageModel {
  surveyQuestionAnswerId: number;
  languageId: number;
  text: string;
  dateCreated: string;
}

export class SurveyQuestionLanguageModel {
  surveyQuestionId: number;
  languageId: number;
  text: string;
  dateCreated: string;
}

export class SurveyItemModel {
  title: string;
  clientName: string;
  createdBy: string;
  status: string;
  surveyType: string;
  dueDate: string;
  importDate: string;
  dateCreated: string;
  numberOfParticipants: number;
  numberOfQuestions: number;
  completedSurveys: number;
  client: SurveyClientModel;
  user: SurveyUserModel;
  isRenaming: boolean;
  workspaceName: string;
  importFromSystem: ImportFromSystemType;
   syncToMailchimp: boolean;
}

export class SurveyClientModel {
  name: string;
}

export class SurveyUserModel {
  id: number;
  firstName: string;
  lastName: string;
}

export class SurveySearchPDModel {
  listEnumModelStatus: any; // define this type with enums
  listSurveyItem: SurveyItemModel[];
  listUserModel: UserModel[];
}

export class UserModel {
  id: number;
  fullName: string;
}

export class AnswerTypes {
  id: number;
  value: string;
  name: string;
}

export class PeopleSurveyCurrencyModel {
  surveyId: number;
  currencyId: number;
  peopleWithCurrCount: number;
  name: string;
  value: number;
}


export class PictureChoiceUploadModel {
  questionId: number;
  answerId: number;
}

export class MasterSummaryPDModel {
  public listQuestionModel: MasterSummaryQuestionModel[];
  public listSurveyVersionQuestion: SurveyVersionQuestionModel[];
  public listSurveyCutQuestion: SurveyCutQuestionModel[];
}

export class SurveyCutQuestionModel {
  public cutId: number;
  public surveyName: string;
  public listQuestionModel: MasterSummaryQuestionModel[];
  public listMissingQuestionId: number[];
  public themeModeSelect: boolean;
  public questionFiltersInCut: SurveyFilterUIModel[];
}

export class SurveyVersionQuestionModel {
  public versionId: string;
  public surveyName: string;
  public listQuestionModel: MasterSummaryQuestionModel[];
  public listMissingQuestionId: number[];
  public themeModeSelect: boolean;
}

export class SurveySummaryAnswerFilter {
  public answerName: string;
  public questionModelCore: MasterSummaryQuestionModel;
}

export class MasterSummaryQuestionModel {
  public id: number;
  public questionName: string;
  public answerType: string;
  public answeredCount: number;
  public answeredPercentage: number;
  public nonAnsweredCount: number;
  public nonAnsweredPercentage: number;
  public averageValue: number;
  public extraId: string;
  public listAnswerModel: MasterSummaryAnswerModel[];

  public listCommonResponse: CommonResponseModel[];
  // added new properties
  public haveAnswered: string;
  public haveNotAnswered: string;
  public chartMenu: boolean;
  public chart: boolean;
  public barChart: boolean;
  public averageResponse: boolean;
  public mostCommonResponse: boolean;
  // Response cloud
  public responseCloudResponse: boolean;
  // Response count
  public responseCountResponse: boolean;
  public listResponseCloudModel: WordCloudResponseModel[];
  // Word cloud
  public wordCloudResponse: boolean;
  // Word count
  public wordCountResponse: boolean;
  public listWordCloudModel: WordCloudResponseModel[];
  public nizPitanja: any[] = [];
  public tableData: boolean;
  public groupQuestionName: string;
  public parentQuestionId: number;
  public defaultChart: SurveyQuestionChartModel;
  public font: string;
  public limit: number;
  public listResponseCloudOriginModel: WordCloudResponseModel[];
  public peopleReponsesCount: number;
  //This property works to see what chart is selected with percentage difference in bar char mode
  public diffPercentageSelected: boolean;
  //this property is for the percentage differences in average responses chart
  public averageDiffPercentage: number;
  //this property is to show the percentage differences in average responses chart
  public averageDiffPercShow: boolean;
  //This property works to see what chart is selected with percentage difference in average response mode
  public diffPercentageSelectedAvgRes: boolean;
  //this property is to see the percentage type selected in bar char mode
  public typePercentageSelected: string;

  public sortModeSelect: string;
  public themeModeSelect = true;
  public chartModeSelect: string;
  public percentageSelected: boolean;

  //this property is to see the percentage type selected in average responses mode
  public averageTypePercentageSelected: string;
  //Copy of the listAnswerModel property
  public copyListAnswerModel: MasterSummaryAnswerModel[];
  //Copy of the nizPitanja property
  public copyNizPitanja: any[] = [];
  //This property is for resetCalculusOfPercentages only if the button themes is pressed
  public resetPercentagesCalculus: boolean;
  public diffSortModeSelected: string;

  public surveyName: string;
  public index: number;
  public themeModeSelectChanged = false;
  public scaleMax: number;
  public compareChartModeSelect: string
}

export class CommonResponseModel {
  public answerName: string;
  public answerPercentage: number;
  public answeredCount: number;
  public answerTheme: string;
}

export class AnsweredObject {
  public answeredCount: number;
  public haveAnswered: string;
  public answerPercentage: number;
  public answerTheme: string;
  public answerName: string;
  public answerDiffPercentage: number;
  public answerDiffPercShow: boolean;
}

export class NonAnsweredObject {
  public answeredCount: number;
  public haveAnswered: string;
  public answerPercentage: number;
  public answerTheme: string;
  public answerName: string;
  public answerDiffPercentage: number;
  public answerDiffPercShow: boolean;
}

export class MasterSummaryAnswerModel {
  public id: string;
  public answerName: string;
  public answerCount: number;
  public answerPercentage: number;
  public answerTheme: string;
  public countAnswerTheme: number;
  public answerDiffPercentage: number;
  public answerDiffPercShow: boolean;
  public questionNumber: number;
}

export class WordCloudResponseModel {
  public answerName: string;
  public answerCount: number;
  public answerPercentage: number;
  public colorHex: string;
  public answerWeight: number;
  public id: number;
  public font: string;
  public limit: number;
}
export class ReportListItemModel {
  public listReportItemModel: ReportItemModel[];
}

export class ReportItemModel {
  public id: number;
  public name: string;
}

export class CreateNewReportModel {
  public listCountry: ListCountryModel[];
  public listCities: string[];
  public listQuestions: ListQuestionsModel[];
  public registeredCount: number;
  public nonRegisteredCount: number;
}

export class ListCountryModel {
  public id: number;
  public name: string;
}

export class ListQuestionsModel {
  public id: number;
  public question: string;
  public listAnswers: ListAnswersModel[];
}

export class ListAnswersModel {
  public id: number;
  public answer: string;
}

export class QuestionFilterModel {
  public id: number;
  public listAnswerId: number[];

  constructor() {
    this.id = 0;
  }

}

export class SaveReportModel {
  public id: number;
  public surveyId: number;
  public jsonValue: string;
  public name: string;
  public ageFrom: number;
  public ageTo: number;
  public gender: number;
  public countryId: number;
  public city: string;
  public listQuestion: QuestionFilterModel[];
}

export class ReportSummaryListModel {
  public listSummary: ReportSummaryItemModel[];
}

export class ReportSummaryItemModel {
  public reportId: number;
  public reportName: string;
  public listQuestion: ReportSummaryQuestion[];
}

export class ReportSummaryQuestion {
  public id: number;
  public questionName: string;
  public answerType: string;
  public answeredCount: number;
  public answeredPercentage: number;
  public nonAnsweredCount: number;
  public nonAnsweredPercentage: number;
  public listAnswer: ReportSummaryAnswer[];
  public defaultChart: SurveyQuestionChartModel;
  // added new properties
  public haveAnswered: string;
  public haveNotAnswered: string;
}

export class ReportSummaryAnswer {
  public id: number;
  public answerName: string;
  public answerCount: number;
  public answerPercentage: number;
  public answerTheme: string;
}

export class ReportForPeopleModel {
  public listPeople: ReportPeopleModel[];
  public listQuestion: ReportQuestion[];
}

export class ReportPeopleModel {
  public id: number;
  public email: string;
  public firstName: string;
  public lastName: string;
  public listQuestionAnswers: ReportQuestionAnswer[];
}

export class ReportQuestion {
  public id: number;
  public question: string;
}

export class ReportQuestionAnswer {
  public questionId: number;
  public answer: string;
  public answerType: string;
}

export class PaymentPDModel {
  public surveyId: number;
  public totalResults: number;
  public completed: number;
  public listPeople: PaymentPeopleModel[];
  public listPaymentForEachCurrency: PaymentCurrencyModel[];
}

export class PaymentPeopleModel {
  public id: number;
  public firstName: string;
  public lastName: string;
  public paypalEmail: string;
  public cost: number;
  public currencyName: string;
  public currencySymbol: string;
  public completionDate: string;
  public payed: boolean;

  // new properties
  public check: boolean;
}

export class PaymentCurrencyModel {
  public currencyId: number;
  public symbol: string;
  public totalCount: number;
  public payedCount: number;
  public payedCost: number;
  public totalCost: number;
}

export class PaidOrNotPaidModel {
  public surveyId: number;
  public paid: boolean;
  public listPeople: number[];
}

export class ListSurveyLanguageHashModel {
  public languageName: string;
  public surveyHash: string;
  public versionName: string;
}

export class SurveyQuestionFilterModel {
  public id: number;
  public surveyId: number;
  public question: string;
  public answerType: string;
  public dateCreated: string;
  public listSurveyQuestionAnserFilterModel: SurveyQuestionAnswerFilterModel[];

  constructor(surveyId: number, question: string, answerType: string) {
    this.surveyId = surveyId;
    this.question = question;
    this.listSurveyQuestionAnserFilterModel = [];
    this.answerType = answerType;
  }
}

export class SurveyQuestionAnswerFilterModel {
  public id: number;
  public surveyQuestionId: number;
  public answer: string;
  public compare: string;
}

export class SurveyUpdateModel {
  id: number;
  workspaceName: string;
}

export class SurveyPermissionModel {
  surveyId: number;
  permission: string;
  userIds: number[];
}

export class SurveyQuestionChartModel {
  public id: number;
  public surveyQuestionId: number;
  public userId: number;
  public chart: string;
}
export class PeopleSurveyAnswerModel {
  public id: number;
  public surveyQuestionId: number;
  public surveyId: number;
  public answer: string;
}
 export class ExclusionCriteriaModel{
  public id: number;
  public surveyId: number;
  public criteriaJson: SurveyFilterUIModel[] ;
  public dateCreated: Date;
  public isOrOperator: string;
 }

export class SurveySimpleModel {
  public id: number;
  public name: string;
}


export class SurveyVersionModel {
  public  nameVersion: string;
  public languajeID: number;

}

export class OutlierModel {
    answerId: string;
    rank: number;
    questionId: number;
    questionNumber: number;
    question: string;
    response: string;
    outlier: string;
    percentageDifference: number;
    // selected percentage icon
    chartJ: number;
    questionI: number;
    isCut: boolean;
    index: number;
    answerPercentage: number;
    removed: boolean;

    constructor() {
        this.removed = false;
    }
}

export class SmartAnalysisModel {
  isAnalysisAll: boolean;
  outliers: OutlierModel[];
}

export class BundleQuestionModel {
    public id: number;
    public surveyId: number;
    public bundleName: string;
    public scaleMax: number;
    public questions: BundleQuestionModelCore[];
}

export class BundleQuestionModelCore {
    public id: number;
    public question: string;
    public answerType: string;
    public index: number;
    public checked = false;
}

export class MasterSummaryQuestionOutlierModel {
    public surveyName: string;
    public question: MasterSummaryQuestionModel;
    public questionFiltersInCut: SurveyFilterUIModel[];

    constructor(surveyName: string, question: MasterSummaryQuestionModel, questionFiltersInCut: SurveyFilterUIModel[]) {
        this.surveyName = surveyName;
        this.question = question;
        this.questionFiltersInCut = questionFiltersInCut;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/survey/survey.model.ts